export default __webpack_public_path__ + "static/media/vid.be58c387.mp4";